namespace Matrix.Workflow {
    export interface WorkflowInstanceDocumentForm {
        WorkflowInstanceId: Serenity.IntegerEditor;
        DocumentId: Serenity.ImageUploadEditor;
        DocumentName: Serenity.StringEditor;
        DocumentDescription: Serenity.StringEditor;
        DocumentGroup: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class WorkflowInstanceDocumentForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.WorkflowInstanceDocument';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WorkflowInstanceDocumentForm.init)  {
                WorkflowInstanceDocumentForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.ImageUploadEditor;
                var w2 = s.StringEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(WorkflowInstanceDocumentForm, [
                    'WorkflowInstanceId', w0,
                    'DocumentId', w1,
                    'DocumentName', w2,
                    'DocumentDescription', w2,
                    'DocumentGroup', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
